import axios from 'axios';

export function isRetryError(error: unknown) {
  return !!(axios.isAxiosError(error) && error.response && error.response.status >= 500);
}
